// extracted by mini-css-extract-plugin
export default {"layout":"BonusWithGamesPopup__layout--2S_","game":"BonusWithGamesPopup__game--1Mq","gameBonusSlider":"BonusWithGamesPopup__gameBonusSlider--5nm"};